import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateExternalConnection } from 'shared/services/backend-api';
import { ExternalConnection } from 'shared/types/external-connections';

import { queryKey as externalEventsQueryKey } from './use-external-calendar-events-query';

export const useUpdateExternalConnectionMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (
      externalConnection: Pick<ExternalConnection, 'id'> &
        Partial<ExternalConnection>,
    ) => {
      await updateExternalConnection(externalConnection);
      await client.invalidateQueries({ queryKey: [externalEventsQueryKey] });
    },
  });
};
